import React, {useState} from 'react';
import {useSelector} from "react-redux";
import {bbFindEntityWithinPortfolioOrSelf, isCurrentUserMemberOf} from "../../../util/bbHelpers";
import {useHistory} from "react-router-dom";
import {makeStyles} from "@material-ui/core/styles";
import Backdrop from "@material-ui/core/Backdrop";
import { Paper} from "@material-ui/core";
import {Col, Row} from "reactstrap";
import BBCodeCopyContainer from "../controllers/BBCodeCopyContainer";
import BBExternalLink from "../accents/BBExternalLink";
import BBIconCodeDocument from "../../../assets/bbCustomIcons/BBIconCodeDocument";
import AlertDialog from "../modals/PopupAlert";


//TODO: this is a legacy styling solution and should be updated to reflect newer MUI
const useStyles = makeStyles(theme => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: '#fff',
        // filter: `blur(3px)`,

    },

    parent: {
        position: "absolute",
        top:0,
        left:0,
        right:0,
        bottom:0,
        // backgroundColor: "rgba(255, 255, 255, 0.25)",
        zIndex: "2000",
        borderRadius: "8px",
        pointerEvents: "all",
    },
    child: {
        filter: `blur(5px)`,
        pointerEvents: "none",

    },
    container: {
        position: "relative",
        width: "100%",
        height: "100%",
        // margin: 0,
        // padding: 0,

    },
    paper: {
        // position: 'fixed',
        // top:0,
        // left:0,
        // right:0,
        // bottom:0,
        // width: 600,
        minWidth: 400,
        maxWidth: 800,
        // backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(4, 8, 6),
    },
}));

const VerifiedOwnershipRequiredDialog = ({children}) =>{

    const classes = useStyles();

    const history = useHistory();
    const {customers, customerInView} = useSelector(({customer}) => customer);
    const authUser = useSelector(({auth}) => auth.authUser);
    const {entityInView, portfolios} = useSelector(({breachrisk})=> breachrisk);
    const isAdminStaff = isCurrentUserMemberOf(authUser, "admin") || isCurrentUserMemberOf(authUser, "staff");
    const customer = customers ? customers[customerInView] : null;

    const customerIdToUse = customers ? customerInView ? customerInView : null : null;

    const [open, setOpen] = useState(true);

    const myEntity = bbFindEntityWithinPortfolioOrSelf(entityInView, portfolios, customerIdToUse);

    const currentPage = history.location.pathname;

    const arrayOfPagesNeedingVerification = [`/board/BreachRisk/Business/Share/Current`, `/board/BreachRisk/Business/Verifications`,`/board/BreachRisk/Business/Attestations`, `/board/BreachRisk/Business/Report/TechData`, `/board/BreachRisk/Business/Report/Social`, `/board/BreachRisk/Business/CloudIntegration` ];

    const ownershipVerified = myEntity
        && myEntity.onboarding_progress
        && myEntity.onboarding_progress.verified_ownership;

    const verification_id = myEntity
        && myEntity.domains
        && Object.values(myEntity.domains)
        && Object.values(myEntity.domains).find(x=> x.is_primary)
        && Object.values(myEntity.domains).find(x => x.is_primary).verification
        && Object.values(myEntity.domains).find(x => x.is_primary).verification.verification_id;

    // console.log("Verifiedownership", ownershipVerified);

    const stillLoadingData = !myEntity || !currentPage;

    if(stillLoadingData){
        return children;
    } else if(!ownershipVerified && isAdminStaff){
        return<>
        <AlertDialog
            title={"Heads Up"}
            description={'You have access to this because you are an admin, but ownership of this company has not been verified.'}
        />
            {children}
        </>
    } else if(!ownershipVerified && arrayOfPagesNeedingVerification.includes(currentPage)){
        return(
            <div className={classes.container}>
                <div className={classes.parent}>
                    <Backdrop className={classes.backdrop} open={true}>
                        <Paper className={"p-3 "} style={{ textAlign: "center" }}>
                            <div className={classes.paper}>
                                <Row>
                                    <Col>
                                        <h1>
                                            Please Confirm Ownership of Your Company Domain
                                        </h1>
                                    </Col>
                                </Row>

                                {/*<Row>*/}
                                {/*    <Col>*/}
                                {/*        <p>*/}
                                {/*            To ensure the safety and integrity of our systems, we require new customers to provide*/}
                                {/*            proof of access before we allow access to the most vulnerable information or tests we provide.*/}
                                {/*        </p>*/}
                                {/*    </Col>*/}
                                {/*</Row>*/}

                                {currentPage === `/board/BreachRisk/Business/Share/Current`
                                && <Row>
                                    <Col>
                                        <p>
                                            To be able to share your company's score or report, you will have to verify your right to share sensitive information for this company.
                                        </p>
                                    </Col>
                                </Row>}

                                {currentPage === `/board/BreachRisk/Business/Verifications`
                                && <Row>
                                    <Col>
                                        <p>
                                            Verifications allow you to add additional elements of your IT infrastructure — additional domains, subdomains, IP addresses, and personnel information. Ensure we know everywhere you exist in cyberspace.
                                        </p>
                                    </Col>
                                </Row>}

                                {currentPage === `/board/BreachRisk/Business/Attestations`
                                && <Row>
                                    <Col>
                                        <p>
                                            Attestations allow you to certify that you've told us about all of your cyberspace. Making attestations at least every 90 days improves the Fidelity of your BreachRisk™ Score.
                                        </p>
                                    </Col>
                                </Row>}

                                {currentPage === `/board/BreachRisk/Business/Report/TechData`
                                && <Row>
                                    <Col>
                                        <p>
                                            To protect the security of our customers, we require proof of authority to conduct security testing before providing sensitive information or enabling testing. </p>
                                    </Col>
                                </Row>}

                                {currentPage === `/board/BreachRisk/Business/Report/Social`
                                && <Row>
                                    <Col>
                                        <p>
                                            Social Engineering access requires you to securely verify that you have a right to view and modify personnel data from or related to this company. 
                                        </p>
                                    </Col>
                                </Row>}
                                
                                <>
                                    <Row>
                                        <Col>
                                            <h4> To confirm your right to access this information, BreachBits&reg; requires you to add the below code as a DNS TXT record for your primary domain.</h4>
                                        </Col>
                                    </Row>

                                    <br/>

                                    <Row>
                                        <Col>
                                            <BBCodeCopyContainer
                                                displayText={verification_id ? verification_id : `Problem finding verification code. Please contact support@breachbits.com.`}
                                                isNotExecutable={true}
                                                titleDescriber={"Required DNS TXT Record"}
                                                language={"plaintext"}
                                                titleIcon={<BBIconCodeDocument/>}
                                                showDownload
                                            />

                                        </Col>
                                    </Row>

                                    <Row className={"mt-1 pt-1 mb-0 pb-0"}>
                                        <Col>
                                            <p className={"mt-1 pt-1 mb-0 pb-0"}><BBExternalLink href={`https://support.breachbits.com/knowledge/why-and-how-to-verify-your-company-with-a-dns-record`}>
                                                Learn more about how to do this and why we require it.
                                            </BBExternalLink> .</p>
                                        </Col>
                                    </Row>
                                </>



                            </div>
                        </Paper>
                    </Backdrop>
                </div>

                <div className={classes.child}>
                    {children}
                </div>
            </div>
            // <div style={style}>
            //     <Dialog
            //         open={open}
            //         aria-labelledby="dialog-title"
            //         aria-describedby="dialog-description"
            //         BackdropProps={{
            //             sx:{
            //                 zIndex: (theme)=> theme.zIndex.drawer + 1,
            //             }
            //         }}
            //     >
            //         <DialogTitle id="dialog-title" className={"text-center"}>Your Account Is Not Ready</DialogTitle>
            //         <DialogContent>
            //             <DialogContentText id="dialog-description">
            //
            //             </DialogContentText>
            //         </DialogContent>
            //         <DialogActions>
            //             <Button onClick={()=>setOpen(false)} color="primary" autoFocus>
            //                 Ok
            //             </Button>
            //         </DialogActions>
            //     </Dialog>
            // </div>
        )
    } else{
        return children
    }


}

export default VerifiedOwnershipRequiredDialog;